<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div v-if="entity.id" :class="[ tab === 'items' ? 'active' : '' ]" @click="tab = 'items'">Items</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li @click="tab = 'items'" v-if="entity.id">
          <a href="#">
            Items
            <i class="fa fa-check-square-o" v-if="tab === 'items'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} and exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-show="tab === 'items' && entity.id">
          <financial-profile-items
            v-if="entity.id"
            :parentId="entity.id"
            :category="entity.category"
          />
        </div>
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="cur-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="cur-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="cur-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="cur-name" v-model="entity.name"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="filter-fp" class="form-label">Category *</label>
              <select class="form-control" id="filter-fp" v-model="entity.category">
                <option value=""></option>
                <option v-for="(opt, i) in categories" :value="opt.value">{{ opt.name }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import API from '../../../../api/endpoints.js'
  import event from '../../../../event.js'
  import FinancialProfileItems from './FinancialProfileItems'
  import Mixin from './Mixin'
  export default {
    name: 'FinancialProfile',
    mixins: [ AdminEntityMixin, HelperMixin, Mixin ],
    components: { FinancialProfileItems },
    data () {
      return {
        newEntityScreen: 'Admin - Financial Profiles',
        editEntityScreen: 'Admin - Edit/View Financial Profiles',
        shouldUpdateCache: true,
        cachePropertyName: null,
        tab: 'main',
        entity: {
          id: null,
          name: null,
          code: null,
          category: null
        },
        boxes: [],
        entityName: 'financial-profile'
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name && this.entity.category &&
          this.entity.code.trim().length > 0 &&
          this.entity.name.trim().length > 0
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          name: null,
          code: null,
          category: null
        }
      }
    },
    watch: {
      'entity.id' (newVal, oldval) {
        this.tab = 'main'
      },
      'entity.category' (newVal, oldVal) {
        this.cachePropertyName = oldVal === 'CHARGE' ? 'chargeProfiles' : null
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/FinancialProfile/FinancialProfile.vue